import { useQueryParams } from '@shared/hooks'

export const useKanbanLeadsQueryParams = () => {
  const queryParams = useQueryParams()

  return {
    lead_type: queryParams.lead_type
      ? [Number(queryParams.lead_type)]
      : undefined,
    source: queryParams.source ? [Number(queryParams.source)] : undefined,
    created_at_from: queryParams.createdAtFrom,
    created_at_to: queryParams.createdAtTo,
    tags: queryParams.tags,
    owner: queryParams.owner ? [queryParams.owner] : undefined,
    sequence: queryParams.sequence ? [Number(queryParams.sequence)] : undefined,
    step: queryParams.step,
    industry: queryParams.industry,
    sub_industry: queryParams.subIndustry,
    size: queryParams.size,
    country: queryParams.country
  }
}
